import { memoizeFunction } from '../../Utilities';
import { mergeStyleSets } from '../../Styling';
export var getStyles = memoizeFunction(function (customStyles) {
    var styles = {
        host: {}
    };
    return mergeStyleSets(styles, customStyles);
});
//# sourceMappingURL=HoverCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/HoverCard/HoverCard.styles.js
// module id = 810
// module chunks = 0